export const isProductDraftRevisionsEnabled = (): boolean =>
  process.env.REACT_APP_PRODUCT_DRAFT_REVISIONS === "true" ||
  process.env.REACT_APP_ENV === "loc";
